import { create, } from "zustand";
import * as IC from "@bracket/react-icons";

import type { MessageId, MessageProps, SendMessageProps, } from "./types";

export declare type MessengerIcon = keyof typeof IC;

export declare type MessengerOptions = {
	icon_success: MessengerIcon;
	icon_failure: MessengerIcon;
	icon_warning: MessengerIcon;
}

export declare type MessengerStore = {
	messages: MessageProps[];
	icon_success: MessengerIcon;
	icon_failure: MessengerIcon;
	applyOptions: ( options?: Partial<MessengerOptions> ) => void;
	sendMessage: ( props: SendMessageProps, ) => void;
	expire: ( message: MessageId, ) => void;
}


export const useMessengerStore = create<MessengerStore>()((set, get) => ({
	icon_success: "TickCircle",
	icon_failure: "CrossCircle",
	messages: [],

	applyOptions: ( options = { }) => {
		set(Object.assign(DefaultMessengerOptions, options));
	},

	sendMessage: ({
		title,
		message,
		severity,
		blockChainLink,
		duration = 5000,
	}: SendMessageProps ) => {

		const { messages, } = get();

		const id = Math.random()
		const next = messages.concat({ id, title, message, duration, severity, created: new Date(), blockChainLink, });

		set({ messages: next, });

		setTimeout(() => {
			const { messages, } = get();
			set({ messages: messages.filter(message => message.id !== id), });
		}, duration);

	},

	expire: ( message ) => {
		const messages = get().messages.filter(m => m.id !== message);
		console.log("M<MMM", messages);
		set({ messages, });
	},

}));

const DefaultMessengerOptions: MessengerOptions = {
	icon_success: "TickCircle",
	icon_failure: "TickCircle",
	icon_warning: "TickCircle",
}
